import {
  EncounterSummaryControllerApi,
  RemoveClinicalDataFromEncounterTypeEnum,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * Remove (unlink) an imported clinical record of a given type
 * (allergy, medical/surgical/family history, medication) from an encounter.
 *
 * Counterpart of `useExportClinicalToEncounter`: it only drops the
 * appointment <-> record link in the join table, so the record stays intact in
 * the patient's chart. Archiving the patient record instead is what caused the
 * clinical data loss when an item was removed from a visit note.
 *
 * Backend: PUT /api/master/encounter-summary/remove-clinical/{type}/{appointmentUuid}/{recordUuid}
 */
export const useRemoveClinicalFromEncounter = () =>
  useMutationWithLoading(
    async (params: {
      type: RemoveClinicalDataFromEncounterTypeEnum;
      appointmentUuid: string;
      recordUuid: string;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).removeClinicalDataFromEncounter(
        params.type,
        params.appointmentUuid,
        params.recordUuid,
        params.xTENANTID
      )
  );
